import { Component, Fragment } from 'react';
import styled from 'styled-components';

import { WebCategory } from '../../../../../../domain/model/category/WebCategory';
import TopicsListFrame from '../../../common/components/js/topics/TopicsListFrame';
import TopicsListItem from '../../../../pc/common/components/js/topics/TopicsListItem';
import TopicsListReadMoreLink from '../../../../pc/common/components/js/topics/TopicsListReadMoreLink';
import { fontSize } from '../../../../common/css/setting/variable';

const TopicsListButtonAll = styled.p`
  margin-left: auto;
`;

const Link = styled.a`
  display: block;
  padding: 8px 0;
  font-size: ${fontSize.px14};

  &:hover {
    color: ${props => props.theme.news.palette.link_hover_pc};
  }
`;

interface IProps {
  list: Array<{
    id: number;
    contentId?: string;
    contentIdType?: string;
    url: string;
    title: string;
    hasVideo: boolean;
    isNew: boolean;
    isLive: boolean;
    useThumbnail: boolean;
    imageUrl: string;
    videoDuration?: string;
    testId?: number;
    articleIsOriginal: boolean;
  }>;
  category?: WebCategory;
  secValue?: string;
  elementId?: string;
  mtestId: string | null;
}

export default class TopicsList extends Component<IProps> {
  /**
   *
   */
  public render() {
    const topicsListItems = this.props.list.map((topics, index) => {
      const position = index + 1;
      const dataClParams = `_cl_vmodule:${this.props.secValue || ''};_cl_link:title;_cl_position:${position};`;
      const contentId = topics.contentId || '';
      const idType = topics.contentIdType || '';
      const elementId = this.props.elementId || '';
      const mtestParam = this.props.mtestId ? `mtestid:${this.props.mtestId};` : '';
      const dataUal = `service:news;opttype:pc;apptype:web;element_id:${elementId};id_type:${idType};content_id:${contentId};${mtestParam}`;
      const dataClParamsString =
        typeof topics.testId === 'number'
          ? `${dataClParams}tpchlid:${topics.id};htestid:${topics.testId};`
          : dataClParams;
      return (
        <TopicsListItem
          {...topics}
          dataClParams={dataClParamsString}
          isPickedImage={topics.useThumbnail}
          key={topics.id}
          dataUal={dataUal}
        />
      );
    });
    const allTopicsLink =
      this.props.category === WebCategory.MAJOR ? (
        <TopicsListButtonAll>
          <Link href="/topics" data-cl-params="_cl_vmodule:tpc_maj;_cl_link:allpcs;">
            全カテゴリのトピックス一覧
          </Link>
        </TopicsListButtonAll>
      ) : null;

    const readMoreLink = (
      <TopicsListReadMoreLink
        category={this.props.category}
        dataClParams={`_cl_vmodule:${this.props.secValue || ''};_cl_link:more;`}
      />
    );

    const button: JSX.Element = (
      <Fragment>
        {readMoreLink} {allTopicsLink}
      </Fragment>
    );

    return <TopicsListFrame main={topicsListItems} button={button} />;
  }
}
